import { render, staticRenderFns } from "./TraceabilityCode.vue?vue&type=template&id=6453e794&scoped=true"
import script from "./TraceabilityCode.vue?vue&type=script&lang=js"
export * from "./TraceabilityCode.vue?vue&type=script&lang=js"
import style0 from "./TraceabilityCode.vue?vue&type=style&index=0&id=6453e794&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6453e794",
  null
  
)

export default component.exports